<div class="col-lg-12 col-md-1"></div>
<div *ngIf="concept && concept.Links && concept.Links.length > 0" class="col-lg-12 col-md-11 margin-top-10">
    <strong style="cursor: pointer;" (click)="showUrls()">
        <i style="color: #337ab7;" [ngClass]="getIconClass()"></i>
        {{concept.Name}}<br/>
    </strong>
    
    <div class="margin-left-20" [ngStyle]="{display: getDivStyle()}">
        <span *ngFor="let aLink of concept.Links">
            <a *ngIf="isBlog(aLink)" [routerLink]='["/blogview", aLink.Alias]' [queryParams]="{ TimeIndex: aLink.TimeIndex}">
                <h5>Blog: {{aLink.Name}} {{GetHumanReadableTimeIndex(aLink)}}</h5>
            </a>
            <a *ngIf="getConceptType(aLink) == 'FoundationsOfLaw'" [routerLink]='["/coursewarecontentview", aLink.Alias]'>
                <h5>Foundations of Law: {{aLink.Name}}</h5>
            </a>
            <a *ngIf="getConceptType(aLink) == 'ShortVideos'" [routerLink]='["/shortvideoscontentview", aLink.Alias]' [queryParams]="{ TimeIndex: aLink.TimeIndex}">
<!--            <a *ngIf="getConceptType(aLink) == 'ShortVideos'" [routerLink]='["/shortvideoscontentview", aLink.Alias, aLink.TimeIndex]'> -->
                <h5>Short Video: {{aLink.Name}}  {{GetHumanReadableTimeIndex(aLink)}}</h5>
            </a>
            <a *ngIf="isVideoCourse(aLink)" [routerLink]='["/videocoursesmoduleview", aLink.Alias]' [queryParams]="{ TimeIndex: aLink.TimeIndex}">
<!--            <a *ngIf="isVideoCourse(aLink)" [routerLink]='["/videocoursesmoduleview", aLink.Alias, aLink.TimeIndex]'> -->
                <h5>Video-Course: {{aLink.Name}}  {{GetHumanReadableTimeIndex(aLink)}}</h5>
            </a>
            <a *ngIf="getConceptType(aLink) == 'Alias'" [routerLink]='["/researchindexview", aLink.Name]'>
                <h5>See {{aLink.Name}}</h5>
            </a>
        </span>
    </div>
</div>
    
    
